'use client';

import { useEffect } from 'react';
import { useNinetailed } from '@ninetailed/experience.js-react';
import { useSearchParams } from 'next/navigation';
import { NINETAILED_ANONYMOUS_ID_COOKIE } from 'utils/cookies';
import { getCookieValue } from 'components/analytics/utils';

export default function NinetailedPage() {
  const { page, identify } = useNinetailed();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Get query parameters for query_params traits
    const queryParams = searchParams.toString();

    // Get the ninetailedId from the cookies
    const ninetailedId = getCookieValue(NINETAILED_ANONYMOUS_ID_COOKIE);

    // Send page event
    page();

    // Send an identify call with the query_params trait
    if (ninetailedId) {
      identify(ninetailedId, {
        query_params: queryParams,
      });
    }
  }, [page, identify, searchParams]);

  return null;
}
